import React from "react";
import "./RouteStrip.css";

export default function RouteStrip({
  origin,
  destination,
  originCity,
  destinationCity,
  flightCode,
  meta,
}) {
  return (
    <div className="trunfo-route-strip" aria-label={`${origin} para ${destination}`}>
      <div className="trunfo-route-strip__endpoint">
        <span className="trunfo-route-strip__iata">{origin}</span>
        {originCity && <span className="trunfo-route-strip__city">{originCity}</span>}
      </div>

      <div className="trunfo-route-strip__path" aria-hidden="true">
        <span className="trunfo-route-strip__dash" />
        <span className="trunfo-route-strip__plane">✈</span>
        <span className="trunfo-route-strip__dash" />
      </div>

      <div className="trunfo-route-strip__endpoint trunfo-route-strip__endpoint--right">
        <span className="trunfo-route-strip__iata">{destination}</span>
        {destinationCity && <span className="trunfo-route-strip__city">{destinationCity}</span>}
      </div>

      {(flightCode || meta) && (
        <div className="trunfo-route-strip__meta">
          {flightCode && <span className="trunfo-route-strip__flight">{flightCode}</span>}
          {meta && <span className="trunfo-route-strip__when">{meta}</span>}
        </div>
      )}
    </div>
  );
}
